export default __webpack_public_path__ + "static/media/LavamanosSanitariodeLujo5.fa493346.png";